import React from 'react'

import { Button, Spinner } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import LegacyDataTable from 'Pods/Shared/DataTable/LegacyDataTable'

import { useFollowers } from '../../Hooks/useFollowers'
import EmptyMessage from '../EmptyMessage'

const renderLink = (username) => <a href={`/profile/${username}`}>{username}</a>

const renderFollowButton = (actionData, onFollowToggle) => {
  const [id, action] = actionData

  if (!action) return null

  const isFollowing = action.method === 'delete'

  return (
    <Button
      type="primary"
      size="tiny"
      customClass="cgt-legacy-text-caption"
      onClick={() => onFollowToggle(id, action)}
    >
      {isFollowing ? 'Unfollow' : 'Follow'}
    </Button>
  )
}

const columnsConfig = {
  id: { visible: false },
  username: { title: 'Username', position: 1 },
  followSince: { title: 'Followed since', position: 2 },
  actions: { title: 'Actions', position: 3 },
}

function Followers() {
  const { followers, isLoading, handleFollowToggle } = useFollowers()

  const followersWithActions = followers.map((follower) => ({
    username: follower.username,
    followSince: follower.followSince,
    actions: [follower.id, follower.action],
  }))

  return (
    <div className="cgt-mb-10">
      {isLoading ? (
        <div className="spinner-container">
          <Spinner />
        </div>
      ) : (
        <LegacyDataTable
          data={followersWithActions}
          columnsConfig={columnsConfig}
          EmptyMessage={(
            <EmptyMessage
              title="Oops, no followers!"
              description="You don't have any followers yet."
            />
          )}
          renderCustomCell={{
            username: renderLink,
            actions: (data) => renderFollowButton(data, handleFollowToggle),
          }}
        />
      )}
    </div>
  )
}

export default Followers
